import axios from 'axios';
import Qs from 'qs';

const axiosInstance = axios.create({
	baseURL: process.env.REACT_APP_CLIENT_API_URL,
	withCredentials: true,
	paramsSerializer: (params) =>
		Qs.stringify(params, {
			arrayFormat: 'brackets',
		}),
});

export default axiosInstance;
